import { YearlyCalculationMode } from '../../api/scheduler-service';

/** UI-only display labels for the YearlyCalculationMode enum.
 *  Backend exposes the enum via @Schema(enumAsRef=true); strings stay UI-side. */
export const YearlyCalculationModeDisplayMap: Record<YearlyCalculationMode, string> = {
  [YearlyCalculationMode.OnSelectedDay]:                 'On Selected Day',
  [YearlyCalculationMode.OnFirstDayOfMonth]:             'On First Day of the Month',
  [YearlyCalculationMode.OnLastDayOfMonth]:              'On Last Day of the Month',
  [YearlyCalculationMode.OnFirstBusinessDayOfMonth]:     'On First Business Day of the Month',
  [YearlyCalculationMode.OnLastBusinessDayOfMonth]:      'On Last Business Day of the Month',
  [YearlyCalculationMode.OnFirstSelectedWeekdayOfMonth]: 'On First Selected Weekday of the Month',
  [YearlyCalculationMode.OnSecondSelectedWeekdayOfMonth]:'On Second Selected Weekday of the Month',
  [YearlyCalculationMode.OnThirdSelectedWeekdayOfMonth]: 'On Third Selected Weekday of the Month',
  [YearlyCalculationMode.OnFourthSelectedWeekdayOfMonth]:'On Fourth Selected Weekday of the Month',
  [YearlyCalculationMode.OnLastSelectedWeekdayOfMonth]:  'On Last Selected Weekday of the Month',
};
